export const COMPANY_INFO = {
  name: 'jakobelektriker.dk',
  cvr: '30867491',
  phone: '22 32 99 79',
  phoneRaw: '22329979',
  email: 'jakobelektriker@hotmail.com',
  address: 'Madegårdsvej 18',
  postal: '5350',
  city: 'Rynkeby',
  country: 'Danmark',
  owner: 'Jakob',
  experience: '25 års erfaring',
  hourlyRate: '485 kr. ex. moms pr. time',
  serviceVanIncluded: 'Inkl. servicevogn',
  noHiddenFees: 'Ingen skjulte tillæg',
  insured: 'Fuldt forsikret',
  cableDiggingPrice: 'Ring for uforpligtende tilbud',
  scissorLiftHeight: '8 meter',
  boomLiftHeight: '10,5 meter',
  cableCapacity: 'Op til ca. 2 km kabel om dagen',
}

export const NAV_LINKS = [
  { label: 'Forside', href: '/' },
  {
    label: 'El-arbejde',
    href: '/el-arbejde',
    description: 'Almindeligt el-arbejde for private og erhverv',
  },
  {
    label: 'Kabeltræk',
    href: '/kabeltraek',
    description: 'Specialist i lange kabeltræk & kabelgravning',
  },
  {
    label: 'Liftarbejde',
    href: '/liftarbejde',
    description: 'Egen saxelift (8m) og bomlift (10,5m)',
  },
  {
    label: 'Designerlamper',
    href: '/designerlamper',
    description: 'Montering og tilbud på danske designerlamper',
  },
  {
    label: 'Erhverv',
    href: '/erhverv',
    description: 'Samarbejde med entreprenører & installatører',
  },
  {
    label: 'Om Jakob',
    href: '/om-jakob',
    description: '25 års erfaring & enkeltmandsforretning',
  },
  {
    label: 'Kontakt',
    href: '/kontakt',
    description: 'Ring direkte til Jakob på 22 32 99 79',
  },
]
